var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col col-12 pa-0"},[_c('v-radio-group',[_c('VRadio'),_c('VRadio')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }